<template>
   <base-content
    :data="data"
    :index="index"
    view="list"
  >
    <template #card-header>
      <partial-title :title="title" :link="link" />
    </template>

    <template #card-body>
      <partial-diseases v-if="!isEmpty(diseases)"
        :diseases="diseases">
      </partial-diseases>
      <partial-interventions v-if="!isEmpty(interventions)"
        :interventions="interventions">
      </partial-interventions>
      <partial-description v-if="!isEmpty(description)"
        :description="description"
        :isLoading="highlightsLoading">
      </partial-description>

      <div class="mt-2 d-flex-col d-sm-flex align-items-center">
        <div v-if="studyType || status" class="t-sm d-flex mr-3 text-nowrap">
          <span v-if="studyType" class="t-600">{{studyType}}</span>
          <span class="mr-1" v-if="studyType && status">, </span>
          <span v-if="status">{{status}}</span>
        </div>
        <ul class="p-0 mr-3 t-overflow">
          <partial-sponsors v-if="!isEmpty(sponsors)" :sponsors="sponsors"/>
        </ul>
        <ul class="p-0">
          <partial-locations v-if="!isEmpty(locations)" :locations="locations"/>
        </ul>
      </div>

      <ul><matches v-if="!isEmpty(matches)" :matches="matches" view="list" /></ul>

    </template>

    <template #card-footer>
      <li v-if="data.start_date" class="row-content">
        <i class="fa fa-hourglass-start row-content--side"></i>
        <span class="row-content--main">{{ data.start_date | formatDate('YYYY-MM-DD') }}<span v-if="data.primary_completion_date"> &#8594; {{ data.primary_completion_date | formatDate('YYYY-MM-DD') }}</span><span v-if="data.completion_date"> &#8594; {{ data.completion_date | formatDate('YYYY-MM-DD') }}</span></span>
      </li>

      <li v-if="!isEmpty(phases)" class="row-content">
        <i class="fa row-content--side fa-flag t-grey"></i>
        <span class="row-content--main">
          <span>{{phases | separateByComma('phase')}}</span>
        </span>
      </li>
    </template>

    <template #card-actions>
      <slot name="actions"></slot>
    </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/clinicalTrial'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialDescription from '@/components/search/results/partials/Description'
import PartialDiseases from '@/components/search/results/partials/Diseases'
import PartialInterventions from '@/components/search/results/partials/Interventions'
import PartialLocations from '@/components/search/results/partials/Locations.vue'
import PartialSponsors from '@/components/search/results/partials/Sponsors.vue'

export default {
  name: 'clinicalTrialResultList',
  mixins: [processing],
  components: {
    Matches,
    PartialTitle,
    BaseContent,
    PartialDescription,
    PartialDiseases,
    PartialInterventions,
    PartialLocations,
    PartialSponsors
  }
}
</script>
